import { EASYBIB, SiteState } from './types'

export default (process.env.REACT_APP_SITE || EASYBIB) as SiteState



// WEBPACK FOOTER //
// ./src/state/site/site.ts